import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import SearchPanel from "../Shared/SearchPanel";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";

const { SITE_NAME } = process.env;

const ComboBanner = ({ service, midtail, city }) => {
	const classes = useStyles("Combo");

	service;
	const targetService = midtail || service;

	const heroPicture =
		SITE_NAME === "tutors"
			? "https://res.cloudinary.com/liaison-inc/image/upload/c_fill,f_auto,q_auto,{SIZE_REPLACE}/services/tutors/backgrounds/math.jpg"
			: `https://res.cloudinary.com/liaison-inc/image/upload/c_fill,f_auto,q_auto,{SIZE_REPLACE}/services/${SITE_NAME}/backgrounds/${targetService.name
					.replace(" & ", "-")
					.replace(",", "")
					.replace(/ /g, "-")}.jpg`;

	// const heroPictureOG = `https://res.cloudinary.com/liaison-inc/image/upload/c_fill,f_auto,q_auto/services/${SITE_NAME}/backgrounds/${targetService.name
	// 	.replace(" & ", "-")
	// 	.replace(",", "")
	// 	.replace(/ /g, "-")}.jpg`;

	// const heroPictureMobile =
	// 	SITE_NAME === "tutors"
	// 		? "https://res.cloudinary.com/liaison-inc/image/upload/c_fill,f_auto,q_auto,w_600/services/tutors/backgrounds/math.jpg"
	// 		: `https://res.cloudinary.com/liaison-inc/image/upload/c_fill,f_auto,q_auto,w_600/services/${SITE_NAME}/backgrounds/${targetService.name
	// 				.replace(" & ", "-")
	// 				.replace(",", "")
	// 				.replace(/ /g, "-")}.jpg`;

	// const heroPictureMobileOG = `https://res.cloudinary.com/liaison-inc/image/upload/c_fill,f_auto,q_auto,w_600/services/${SITE_NAME}/backgrounds/${targetService.name
	// 	.replace(" & ", "-")
	// 	.replace(",", "")
	// 	.replace(/ /g, "-")}.jpg`;

	const h1 = `Find ${
		targetService.plural
			? targetService.plural
			: targetService.phrase.toLowerCase()
	} in ${city.name.ucFirst()}, ${city.state.toUpperCase()}`;
	const subheader = `Share a few details and we'll show you the best ${
		targetService.plural_2
			? targetService.plural_2
			: targetService.plural
			? targetService.plural.toLowerCase()
			: targetService.phrase.toLowerCase()
	} in your area.`;

	const replaceSize = (src, size) => src.replace("{SIZE_REPLACE}", size);

	return (
		<React.Fragment>
			<section className={classes.hero}>
				<picture className={classes.picture}>
					<source
						srcSet={`${replaceSize(
							heroPicture,
							"h_200,w_400"
						)} 400w, ${replaceSize(
							heroPicture,
							"h_400,w_768"
						)} 768w, ${replaceSize(heroPicture, "w_1200")} 1200w`}
						sizes="100vw"
					/>
					<img
						sizes="100vw"
						srcSet={`${replaceSize(
							heroPicture,
							"h_200,w_400"
						)} 400w, ${replaceSize(
							heroPicture,
							"h_400,w_768"
						)} 768w, ${replaceSize(heroPicture, "w_1200")} 1200w`}
						src={replaceSize(heroPicture, "w_1200")}
						alt={`Find a ${
							targetService.singular
								? targetService.singular.toLowerCase()
								: targetService.phrase.toLowerCase()
						} in ${city.name.ucFirst()}, ${city.state.toUpperCase()}`}
						className={classes.backgroundImage}
						fetchpriority="high"
					/>
				</picture>

				<Box
					height="100%"
					display={{ xs: "flex", sm: "none" }}
					alignItems="flex-end"
					position="relative"
					color="#FFF"
					py={4}
					px={4}
					className={classes.pictureGradient}
				>
					<h1 className={classes.h1}>{h1}</h1>
				</Box>

				<Box
					width="100%"
					left={0}
					top="50%"
					pr={2}
					pl={2}
					className={classes.heroBox}
				>
					<Container maxWidth="md">
						<Box
							display={{ xs: "none", sm: "block" }}
							p={8}
							borderRadius={12}
							maxWidth={505}
							boxShadow={5}
							bgcolor="#FFF"
						>
							<SearchPanel
								h1={h1}
								id={"big"}
								subheader={subheader}
								quickPickQuestions={service?.questions}
							/>
						</Box>
					</Container>
				</Box>

				{/*<Box display={{xs: 'none', sm: 'none', md: 'block'}} position="absolute" textAlign="right"*/}
				{/*     color="#FFF" className={classes.floatingText}*/}
				{/*     p={6} bottom={0} right={0}>*/}
				{/*    {`100+ ${service.name.ucFirst()} ${proAdjective.plural} near ${city.name.ucFirst()}, ${city.state.toUpperCase()}`}*/}
				{/*</Box>*/}
			</section>

			<Box
				display={{ xs: "block", sm: "none" }}
				p={4}
				maxWidth="100%"
				bgcolor="#FFF"
			>
				<SearchPanel
					id={"small"}
					h1={h1}
					subheader={subheader}
					quickPickQuestions={service?.questions}
				/>
			</Box>
		</React.Fragment>
	);
};

ComboBanner.propTypes = {
	zipcode: PropTypes.string,
	service: PropTypes.shape({
		name: PropTypes.string.isRequired,
		questions: PropTypes.array.isRequired,
	}).isRequired,
	city: PropTypes.shape({
		name: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
	}).isRequired,
};

export default ComboBanner;
